export default class BaseRoutes {
  constructor() {
    this.isProxy = true;
    this.isArea = true;
    this.baseUrl = "/";
    this.nav = false;
    this.routes = {};
    this.states = {};
  }
  register($stateProvider, $urlRouterProvider) {
    this.registerStates($stateProvider);
    this.registerRoutes($urlRouterProvider);
  }
  registerStates($stateProvider) {
    Object.keys(this.states).forEach((k) =>
      $stateProvider.state(k, this.states[k])
    );
  }
  isRoot() {
    return !this.isProxy && this.isArea;
  }
  registerRoutes($urlRouterProvider) {
    Object.keys(this.routes).forEach((k) =>
      $urlRouterProvider.when(k, this.routes[k])
    );
    if (this.isRoot()) {
      $urlRouterProvider.when(this.baseUrl, "/");
      $urlRouterProvider.otherwise("/");
    }
  }
  resolveProxy($window, $stateParams, $location, baseUrl) {
    if (this.isProxy) {
      let params = Object.assign({}, $stateParams, $location.search());
      let href = baseUrl || `${this.baseUrl}/`;
      Object.keys(params)
        .filter((k) => params[k])
        .forEach((k, i) => {
          href += `${(i === 0 ? "?" : "&") + k}=${encodeURIComponent(
            params[k]
          )}`;
        });
      //var result = $window.location.replace(href);
      $window.location.href = href;
      console.warn("resolveProxy", href, params);
      throw new Error(href);
    }
  }
}
